import { WidgetCustomManagedStreamConfig } from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import { VolumeCurveStreamManager } from 'widgets/volumeCurve/store/data/VolumeCurveStreamManager.ts';

export const volumeCurveStreamConfig: WidgetCustomManagedStreamConfig = {
    channelDestination: 'startVolumeCurveStream',
    managerFactory: (options) => new VolumeCurveStreamManager(options),
};
